import type { ReactNode } from "react";

function inline(text: string, keyBase: string): ReactNode[] {
  const out: ReactNode[] = [];
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;
  let last = 0; let m: RegExpExecArray | null; let i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const tok = m[0];
    out.push(tok.startsWith("**")
      ? <strong key={`${keyBase}-${i++}`}>{tok.slice(2, -2)}</strong>
      : <em key={`${keyBase}-${i++}`}>{tok.slice(1, -1)}</em>);
    last = m.index + tok.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

/** Tiny, safe markdown subset for artist terms. Everything is rendered as React text — no HTML. */
export function MiniMarkdown({ source }: { source: string }) {
  const blocks: ReactNode[] = [];
  let bullets: string[] = [];
  let para: string[] = [];
  const flush = (k: number) => {
    if (bullets.length) {
      blocks.push(<ul key={`u${k}`} className="list-disc space-y-1 pl-5">{bullets.map((b, i) => <li key={i}>{inline(b, `u${k}-${i}`)}</li>)}</ul>);
      bullets = [];
    }
    if (para.length) { blocks.push(<p key={`p${k}`}>{inline(para.join(" "), `p${k}`)}</p>); para = []; }
  };
  source.replace(/\r\n/g, "\n").split("\n").forEach((raw, k) => {
    const line = raw.trim();
    if (!line) return flush(k);
    const h = line.match(/^#{1,6}\s+(.*)$/);
    if (h) { flush(k); blocks.push(<h4 key={`h${k}`} className="font-medium text-[var(--color-text)]">{inline(h[1], `h${k}`)}</h4>); return; }
    const b = line.match(/^[-*•]\s+(.*)$/);
    if (b) { if (para.length) flush(k); bullets.push(b[1]); return; }
    if (bullets.length) flush(k);
    para.push(line);
  });
  flush(-1);
  return <div className="space-y-2 text-sm text-[var(--color-text-muted)]">{blocks}</div>;
}
